import { render, staticRenderFns } from "./ApplicationLanguageControl.vue?vue&type=template&id=be0e6f3a"
import script from "./ApplicationLanguageControl.vue?vue&type=script&lang=js"
export * from "./ApplicationLanguageControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be0e6f3a')) {
      api.createRecord('be0e6f3a', component.options)
    } else {
      api.reload('be0e6f3a', component.options)
    }
    module.hot.accept("./ApplicationLanguageControl.vue?vue&type=template&id=be0e6f3a", function () {
      api.rerender('be0e6f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/ApplicationLanguageControl.vue"
export default component.exports